import * as React from "react";
import { Route, RouteComponentProps, RouteProps } from "react-router-dom";

import LargeScreenOnlyContainer from "../../components/Containers/LargeScreenOnlyContainer";
import AuthedContainer from "./AuthedContainer";

interface IProps extends RouteProps {
  authed?: boolean;
  desktopOnly?: boolean;
  component: React.ComponentType<any>;
  mobileComponent?: React.ComponentType<any>;
}

const PASS_THROUGH = (props: any) => props.children;

export default class SLRoute extends React.Component<IProps> {
  public render() {
    const props = { ...this.props, component: undefined };
    return <Route {...props} render={this.renderContent} />;
  }

  private renderContent = (props: RouteComponentProps<IProps>) => {
    const { component, desktopOnly, authed, mobileComponent } = this.props;
    const Component = component;
    const DesktopOnly: React.ComponentType<any> = desktopOnly
      ? LargeScreenOnlyContainer
      : PASS_THROUGH;
    const Authed = authed ? AuthedContainer : PASS_THROUGH;

    return (
      <DesktopOnly MobileComponent={mobileComponent}>
        <Authed>
          <Component {...props} />
        </Authed>
      </DesktopOnly>
    );
  };
}



// WEBPACK FOOTER //
// ./src/scenes/Navigation/SLRoute.tsx